export const getDateMinimum = () => {
    return new Date('1900-01-01');
};
export const getDateMinimumString = () => {
    return getDateMinimum().toISOString().split('T')[0];
};

export const getDateMaximum = () => {
    return new Date(new Date().valueOf() - 86400000)
};
export const getDateMaximumString = () => {
    return getDateMaximum().toISOString().split('T')[0];
};

export const handleCustomValidityOfDateField = (t: any, input: HTMLInputElement, requiredErrorLocKey: string, minimumDatErrorLocKey: string) => {
    input.setCustomValidity('');
    if (!input.validity.valid) {
        input.setCustomValidity(t(input.value ? requiredErrorLocKey : minimumDatErrorLocKey));
    }
};

export const handleCustomValidityOfDateFieldWithMinMax = (t: any, input: HTMLInputElement, minimumDateErrorLocKey: string, maximumDateErrorLocKey: string) => {
    input.setCustomValidity('');
    const date = new Date(input.value);

    if (date > getDateMaximum()) {
        input.setCustomValidity(t(maximumDateErrorLocKey));
    } else if (date < new Date(getDateMinimum())) {
        input.setCustomValidity(t(minimumDateErrorLocKey));
    }
};
